module.exports = __webpack_public_path__ + "static/media/IsimIcinDefaultImage.703d046e.png";